import {colorSwatch} from '../utils/colorSwatch.js';
import {MenuPanels} from '../../models/UIModel.js';
import React, {useState} from 'react';
import {parseColor} from '../utils/utils.js';
import {MenuButton} from '../components/menu-button.js';
import {isSoundTurnedOn, toggleSound, ToggleType} from '../utils/toggleSound.js';
import {Column, Container, Text} from '@wonderlandengine/react-ui/components';
import {Align, FlexDirection, Justify, YogaNodeProps} from '@wonderlandengine/react-ui';
import {goToMenu} from '../utils/goToMenu.js';
import {
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {Material} from '@wonderlandengine/api';
import {WindowHeader} from '../components/window-header.js';
import {openLink} from '../utils/openLink.js';

// @ts-ignore TypeScript doesn't support it anymore, but ESBuild does
import {version} from '../../../package.json';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Localization} from '../../utils/Localization.js';
import {goToCredits} from '../utils/goToCredits.js';
import {isOnPlatform, Platforms} from '../utils/isOnPlatform.js';

let bm: Material | null;

export const OptionsMenuPanel = (props: React.PropsWithChildren<YogaNodeProps> & {}) => {
    const rotbMats = useRotBMaterialContext() as RotBMaterialContextValue;
    const material = rotbMats.titleBackgroundMaterial;

    // TK: This prevents the material to be cloned every time the component is rendered.
    // Probably needs to be useMemo or something, but that keeps getting reloaded anyway.
    if (!bm) {
        bm = material!.clone();
        (bm as any).setColor(parseColor(colorSwatch.TitleBackground));
    }

    const [soundEnabled, setSoundEnabled] = useState(isSoundTurnedOn(ToggleType.Sound));
    const [musicEnabled, setMusicEnabled] = useState(isSoundTurnedOn(ToggleType.Music));
    const [showMoreGames] = useState(!isOnPlatform(Platforms.CrazyGames));

    const toggleMusic = () => {
        toggleSound(ToggleType.Music);
        setMusicEnabled(isSoundTurnedOn(ToggleType.Music));
    };

    const toggleAudio = () => {
        toggleSound(ToggleType.Sound);
        setSoundEnabled(isSoundTurnedOn(ToggleType.Sound));
    };

    return (
        <Column
            height="100%"
            margin={20}
            alignSelf={Align.Center}
            width={500}
            rowGap={20}
            alignContent={Align.Center}
            justifyContent={Justify.FlexStart}
        >
            <WindowHeader title={Localization.instance.get('Options')} />
            <Container width={450} alignSelf={Align.Center}>
                <MenuButton
                    margin={12}
                    height={70}
                    color={colorSwatch.GenericButton1}
                    fontSize={32}
                    icon={UiTexturesManager.instance.trophyWhite}
                    iconWidth={40}
                    iconHeight={40}
                    ignoreIconForCentering={true}
                    onClick={() => goToMenu(MenuPanels.Achievements)}
                >
                    {Localization.instance.get('Achievements')}
                </MenuButton>
                <MenuButton
                    height={70}
                    margin={12}
                    color={colorSwatch.GenericButton2}
                    fontSize={32}
                    icon={UiTexturesManager.instance.info}
                    iconWidth={38}
                    iconHeight={40}
                    ignoreIconForCentering={true}
                    onClick={() => goToMenu(MenuPanels.Stats)}
                >
                    {Localization.instance.get('Stats')}
                </MenuButton>
                {showMoreGames && (
                    <MenuButton
                        height={70}
                        margin={12}
                        color={colorSwatch.GenericButton3}
                        fontSize={32}
                        icon={UiTexturesManager.instance.moreGames}
                        iconWidth={40}
                        iconHeight={40}
                        ignoreIconForCentering={true}
                        onClick={() => goToMenu(MenuPanels.Games)}
                    >
                        {Localization.instance.get('MoreGames')}
                    </MenuButton>
                )}
                <MenuButton
                    height={70}
                    margin={12}
                    color={colorSwatch.GenericButton4}
                    fontSize={32}
                    onClick={() => goToCredits()}
                >
                    {Localization.instance.get('Credits')}
                </MenuButton>
                <MenuButton
                    height={70}
                    margin={12}
                    color={colorSwatch.GenericButton5}
                    fontSize={32}
                    onClick={() => openLink('https://discord.gg/MdbVSc2NyE')}
                >
                    {Localization.instance.get('Support')}
                </MenuButton>
            </Container>
            <Container flexGrow={1}></Container>
            <Container
                width="100%"
                flexDirection={FlexDirection.Row}
                justifyContent={Justify.Center}
            >
                <MenuButton
                    width={210}
                    height={80}
                    margin={12}
                    color={colorSwatch.MusicButton}
                    fontSize={20}
                    icon={
                        musicEnabled
                            ? UiTexturesManager.instance.musicIcon
                            : UiTexturesManager.instance.musicIconDisabled
                    }
                    iconWidth={40}
                    iconHeight={40}
                    onClick={toggleMusic}
                >
                    {Localization.instance.get('MusicFormat')}
                </MenuButton>
                <MenuButton
                    width={210}
                    height={80}
                    margin={12}
                    color={colorSwatch.MusicButton}
                    fontSize={20}
                    icon={
                        soundEnabled
                            ? UiTexturesManager.instance.soundSpeaker
                            : UiTexturesManager.instance.soundSpeakerDisabled
                    }
                    iconWidth={40}
                    iconHeight={40}
                    onClick={toggleAudio}
                >
                    {Localization.instance.get('SFXFormat')}
                </MenuButton>
            </Container>
            <Container alignItems={Align.Center} height={80}>
                <Text
                    textAlign="center"
                    fontSize={16}
                    color={colorSwatch.SubTitleBackground}
                    text={`Version ${version}`}
                ></Text>
            </Container>
        </Column>
    );
};
